/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CommonResponse } from '../model';
// @ts-ignore
import { Email } from '../model';
// @ts-ignore
import { EmailConfirmation } from '../model';
// @ts-ignore
import { IdentityResponse } from '../model';
/**
 * EmailApi - axios parameter creator
 * @export
 */
export const EmailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This resends an email that has a confirmation code.
         * @summary Organization - Email address resend
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOrganizationOtpEmail: async (email: Email, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('resendOrganizationOtpEmail', 'email', email)
            const localVarPath = `/v1/entity/organization/email/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = email

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This resends an email that has a confirmation code.
         * @summary Individual - Email address resend
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOtpEmail: async (email: Email, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('resendOtpEmail', 'email', email)
            const localVarPath = `/v1/entity/individual/email/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = email

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This updates an email address.
         * @summary Organization - Email address update
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationEmail: async (email: Email, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('updateOrganizationEmail', 'email', email)
            const localVarPath = `/v1/entity/organization/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = email

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This confirms an email address.
         * @summary Individual - Email address confirmation
         * @param {EmailConfirmation} emailConfirmation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail: async (emailConfirmation: EmailConfirmation, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailConfirmation' is not null or undefined
            assertParamExists('verifyEmail', 'emailConfirmation', emailConfirmation)
            const localVarPath = `/v1/entity/individual/email/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = emailConfirmation

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This confirms an email address.
         * @summary Organization - Email address confirmation
         * @param {EmailConfirmation} emailConfirmation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOrganizationEmail: async (emailConfirmation: EmailConfirmation, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailConfirmation' is not null or undefined
            assertParamExists('verifyOrganizationEmail', 'emailConfirmation', emailConfirmation)
            const localVarPath = `/v1/entity/organization/email/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = emailConfirmation

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailApi - functional programming interface
 * @export
 */
export const EmailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailApiAxiosParamCreator(configuration)
    return {
        /**
         * This resends an email that has a confirmation code.
         * @summary Organization - Email address resend
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendOrganizationOtpEmail(email: Email, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendOrganizationOtpEmail(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This resends an email that has a confirmation code.
         * @summary Individual - Email address resend
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendOtpEmail(email: Email, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendOtpEmail(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This updates an email address.
         * @summary Organization - Email address update
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationEmail(email: Email, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationEmail(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This confirms an email address.
         * @summary Individual - Email address confirmation
         * @param {EmailConfirmation} emailConfirmation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyEmail(emailConfirmation: EmailConfirmation, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEmail(emailConfirmation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This confirms an email address.
         * @summary Organization - Email address confirmation
         * @param {EmailConfirmation} emailConfirmation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyOrganizationEmail(emailConfirmation: EmailConfirmation, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyOrganizationEmail(emailConfirmation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmailApi - factory interface
 * @export
 */
export const EmailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailApiFp(configuration)
    return {
        /**
         * This resends an email that has a confirmation code.
         * @summary Organization - Email address resend
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOrganizationOtpEmail(email: Email, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.resendOrganizationOtpEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * This resends an email that has a confirmation code.
         * @summary Individual - Email address resend
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOtpEmail(email: Email, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.resendOtpEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * This updates an email address.
         * @summary Organization - Email address update
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationEmail(email: Email, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.updateOrganizationEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * This confirms an email address.
         * @summary Individual - Email address confirmation
         * @param {EmailConfirmation} emailConfirmation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail(emailConfirmation: EmailConfirmation, options?: any): AxiosPromise<IdentityResponse> {
            return localVarFp.verifyEmail(emailConfirmation, options).then((request) => request(axios, basePath));
        },
        /**
         * This confirms an email address.
         * @summary Organization - Email address confirmation
         * @param {EmailConfirmation} emailConfirmation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOrganizationEmail(emailConfirmation: EmailConfirmation, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.verifyOrganizationEmail(emailConfirmation, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailApi - interface
 * @export
 * @interface EmailApi
 */
export interface EmailApiInterface {
    /**
     * This resends an email that has a confirmation code.
     * @summary Organization - Email address resend
     * @param {Email} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApiInterface
     */
    resendOrganizationOtpEmail(email: Email, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This resends an email that has a confirmation code.
     * @summary Individual - Email address resend
     * @param {Email} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApiInterface
     */
    resendOtpEmail(email: Email, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This updates an email address.
     * @summary Organization - Email address update
     * @param {Email} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApiInterface
     */
    updateOrganizationEmail(email: Email, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This confirms an email address.
     * @summary Individual - Email address confirmation
     * @param {EmailConfirmation} emailConfirmation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApiInterface
     */
    verifyEmail(emailConfirmation: EmailConfirmation, options?: AxiosRequestConfig): AxiosPromise<IdentityResponse>;

    /**
     * This confirms an email address.
     * @summary Organization - Email address confirmation
     * @param {EmailConfirmation} emailConfirmation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApiInterface
     */
    verifyOrganizationEmail(emailConfirmation: EmailConfirmation, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

}

/**
 * EmailApi - object-oriented interface
 * @export
 * @class EmailApi
 * @extends {BaseAPI}
 */
export class EmailApi extends BaseAPI implements EmailApiInterface {
    /**
     * This resends an email that has a confirmation code.
     * @summary Organization - Email address resend
     * @param {Email} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public resendOrganizationOtpEmail(email: Email, options?: AxiosRequestConfig) {
        return EmailApiFp(this.configuration).resendOrganizationOtpEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This resends an email that has a confirmation code.
     * @summary Individual - Email address resend
     * @param {Email} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public resendOtpEmail(email: Email, options?: AxiosRequestConfig) {
        return EmailApiFp(this.configuration).resendOtpEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This updates an email address.
     * @summary Organization - Email address update
     * @param {Email} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public updateOrganizationEmail(email: Email, options?: AxiosRequestConfig) {
        return EmailApiFp(this.configuration).updateOrganizationEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This confirms an email address.
     * @summary Individual - Email address confirmation
     * @param {EmailConfirmation} emailConfirmation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public verifyEmail(emailConfirmation: EmailConfirmation, options?: AxiosRequestConfig) {
        return EmailApiFp(this.configuration).verifyEmail(emailConfirmation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This confirms an email address.
     * @summary Organization - Email address confirmation
     * @param {EmailConfirmation} emailConfirmation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public verifyOrganizationEmail(emailConfirmation: EmailConfirmation, options?: AxiosRequestConfig) {
        return EmailApiFp(this.configuration).verifyOrganizationEmail(emailConfirmation, options).then((request) => request(this.axios, this.basePath));
    }
}
